var ttAutoMoreNav = {
  init: function () {
    var bar_el = $('.automore-nav-bar');
    var nav_el = bar_el.find('nav');
    var btn_el = bar_el.find('.btn-more');
    var bar_h = bar_el.innerHeight();

    if (bar_el.length == 0) return;

    var show_more_btn = function () {
      var nav_h = nav_el.innerHeight();

      bar_el.removeClass('show_more_btn');

      if (nav_h > bar_h) {
        bar_el.addClass('show_more_btn');
        if (bar_el.is('.show_more')) {
          bar_el.css('height', nav_el.innerHeight());
        }
      } else {
        nav_close();
      }
    }

    var nav_open = function () {
      bar_el.addClass('show_more').css('height', nav_el.innerHeight());

      $(window).on('click.automorenav', function (e) {
        if (!$(e.target).closest('.automore-nav-bar').length) {
          nav_close();
        }
      });
      
      $('input').on('focus', function () {
        nav_close();
      });
    }

    var nav_close = function () {
      bar_el.removeClass('show_more').css('height', '');
      $(window).off('click.automorenav');
    }

    btn_el.off('click').on('click', function (e) {
      e.preventDefault();
      if (bar_el.is('.show_more')) {
        nav_close();
      } else {
        nav_open();
      }
    });


    show_more_btn();

    if (html_el.is('.mutationobserver')) {
      var resize_obs = new ResizeObserver((entries) => {
        for (var entry of entries) {
          // console.log('新尺寸:', entry.contentRect.width);
          show_more_btn();
        }
      });
      // 观察目标元素  
      resize_obs.observe(nav_el[0]);
    } else {
      $(window).off('resize.automorenav').on('resize.automorenav', show_more_btn);
    }

  }
}